import { LinearProgress, Tooltip } from "@mui/material";
import { t } from "i18next";
import React from "react";
import { useSelector } from "react-redux";
import CircleRoundedIcon from "@mui/icons-material/CircleRounded";
import InsertDriveFileRoundedIcon from "@mui/icons-material/InsertDriveFileRounded";
import EuroSymbolRoundedIcon from "@mui/icons-material/EuroSymbolRounded";
import CoreSpinner from "../../../../../app/core/components/CoreSpinner/CoreSpinner";

const GestioneDocumentiStats = ({ data, isPolling, pollingCounter }) => {
  const primaryColor = useSelector((state) => state.app.primaryColor);
  const secondaryColor = useSelector((state) => state.app.secondaryColor);
  const appConfig = useSelector((state) => state.app.appConfig);

  return (
    <>
      <div
        style={{
          border: `1px solid lightgrey`,
          borderRadius: 10,
          padding: 10,
        }}
        className="flex flex-row items-center justify-start space-x-6"
      >
        {isPolling ? (
          <>
            <LinearProgress
              sx={{
                width: 175,
                height: 9,
                borderRadius: 8,
                backgroundColor: secondaryColor,
                "& .MuiLinearProgress-bar": { backgroundColor: primaryColor },
              }}
              variant="determinate"
              value={(pollingCounter * 100) / 8}
            />
            <div
              className="font-semibold flex items-center gap-1"
              style={{ color: primaryColor }}
            >
              {t("Sync...")}
              <CoreSpinner size={12} />
            </div>
          </>
        ) : (
          <>
            {appConfig.modules.documents.statsCountDoc && (
              <Tooltip title={t("DocumentsCount")}>
                <div className="flex space-x-1">
                  <InsertDriveFileRoundedIcon style={{ color: "gray" }} />
                  <span
                    className="font-bold m-0"
                    style={{ color: primaryColor }}
                  >
                    {data?.count}
                  </span>
                </div>
              </Tooltip>
            )}

            {appConfig.modules.documents.statsAmountDoc && (
              <Tooltip title={t("Total")}>
                <div className="flex space-x-1">
                  <EuroSymbolRoundedIcon style={{ color: "gray" }} />
                  <span
                    className="font-bold m-0"
                    style={{ color: primaryColor }}
                  >
                    {data?.sum.toLocaleString("it-IT")}
                  </span>
                </div>
              </Tooltip>
            )}

            {appConfig.modules.documents.statsStatusDoc && (
              <div className="flex space-x-4">
                <Tooltip title={t("Validateds")}>
                  <div className="flex space-x-1">
                    <CircleRoundedIcon style={{ color: "#359F1C" }} />
                    <span
                      className="font-bold m-0"
                      style={{ color: primaryColor }}
                    >
                      {data?.validatedDocsCount}
                    </span>
                  </div>
                </Tooltip>

                <Tooltip title={t("ToValidate")}>
                  <div className="flex space-x-1">
                    <CircleRoundedIcon style={{ color: "#D86F07" }} />
                    <span
                      className="font-bold m-0"
                      style={{ color: primaryColor }}
                    >
                      {data?.pendingDocsCount}
                    </span>
                  </div>
                </Tooltip>

                <Tooltip title={t("Discardeds")}>
                  <div className="flex space-x-1">
                    <CircleRoundedIcon style={{ color: "#C1272D" }} />
                    <span
                      className="font-bold m-0"
                      style={{ color: primaryColor }}
                    >
                      {data?.rejectedDocsCount}
                    </span>
                  </div>
                </Tooltip>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default GestioneDocumentiStats;
